export const CONTRACTS_LIST_INITING             = 'CONTRACTS_LIST_INITING'
export const CONTRACTS_LIST_REQUESTING          = 'CONTRACTS_LIST_REQUESTING'
export const CONTRACTS_LIST_SUCCESS             = 'CONTRACTS_LIST_SUCCESS'
export const CONTRACTS_LIST_ERROR               = 'CONTRACTS_LIST_ERROR'   

export const CONTRACTS_TRANGTHAI_INITING        = 'CONTRACTS_TRANGTHAI_INITING'
export const CONTRACTS_TRANGTHAI_REQUESTING     = 'CONTRACTS_TRANGTHAI_REQUESTING'
export const CONTRACTS_TRANGTHAI_SUCCESS        = 'CONTRACTS_TRANGTHAI_SUCCESS'
export const CONTRACTS_TRANGTHAI_ERROR          = 'CONTRACTS_TRANGTHAI_ERROR'   

export const CONTRACTS_LOAI_INITING             = 'CONTRACTS_LOAI_INITING'
export const CONTRACTS_LOAI_REQUESTING          = 'CONTRACTS_LOAI_REQUESTING'
export const CONTRACTS_LOAI_SUCCESS             = 'CONTRACTS_LOAI_SUCCESS'
export const CONTRACTS_LOAI_ERROR               = 'CONTRACTS_LOAI_ERROR'  

export const CONTRACTS_NHANVIEN_INITING         = 'CONTRACTS_NHANVIEN_INITING'
export const CONTRACTS_NHANVIEN_REQUESTING      = 'CONTRACTS_NHANVIEN_REQUESTING'
export const CONTRACTS_NHANVIEN_SUCCESS         = 'CONTRACTS_NHANVIEN_SUCCESS'
export const CONTRACTS_NHANVIEN_ERROR           = 'CONTRACTS_NHANVIEN_ERROR'  

export const CONTRACTS_KHACHHANG_INITING        = 'CONTRACTS_KHACHHANG_INITING'
export const CONTRACTS_KHACHHANG_REQUESTING     = 'CONTRACTS_KHACHHANG_REQUESTING'
export const CONTRACTS_KHACHHANG_SUCCESS        = 'CONTRACTS_KHACHHANG_SUCCESS'
export const CONTRACTS_KHACHHANG_ERROR          = 'CONTRACTS_KHACHHANG_ERROR' 

export const CONTRACTS_DETAIL_INITING           = 'CONTRACTS_DETAIL_INITING'
export const CONTRACTS_DETAIL_REQUESTING        = 'CONTRACTS_DETAIL_REQUESTING'
export const CONTRACTS_DETAIL_SUCCESS           = 'CONTRACTS_DETAIL_SUCCESS'
export const CONTRACTS_DETAIL_ERROR             = 'CONTRACTS_DETAIL_ERROR'   

export const CONTRACTS_UPDATE_REQUESTING        = 'CONTRACTS_UPDATE_REQUESTING'
export const CONTRACTS_UPDATE_SUCCESS           = 'CONTRACTS_UPDATE_SUCCESS'
export const CONTRACTS_UPDATE_ERROR             = 'CONTRACTS_UPDATE_ERROR'   

export const CONTRACTS_DETAIL_API               = '/api/v1/hopdong/get_detail_hopdong'  
export const CONTRACTS_LIST_API                 = '/api/v1/hopdong/get_list_hopdong'  
export const CONTRACTS_TRANGTHAI_API            = '/api/v1/hopdong/get_list_trangthai_hopdong'  
export const CONTRACTS_LOAI_API                 = '/api/v1/hopdong/get_list_loai_hopdong'  
export const CONTRACTS_NHANVIEN_API             = '/api/v1/hopdong/get_list_nhanvien'  
export const CONTRACTS_UPDATE_API               = '/api/v1/hopdong/update_hop_dong' 
export const CONTRACTS_KHACHHANG_API            = '/api/v1/khachhang/khachhang_list_by_store'  


// WEBPACK FOOTER //
// ./src/views/Contracts/constants.js